import { useMemo } from 'react';
import { dappConfig } from './../config';
import { GraphQLClient } from 'graphql-request';

export const useClient = () =>
  useMemo(() => new GraphQLClient(dappConfig.graphSettings.endpoint), []);
